import { createContext, useContext } from 'react';

import { ChooserAdapter } from '../services/ChooserAdapter';

export type AppContextType = {
  showError: (error: string) => void;
  showAlert: (alert: string) => void;
  chooserAdapter: ChooserAdapter;
  googlePlacesApiKey?: string;
  userCountry?: string;
};

export const AppContext = createContext(undefined as AppContextType);

export function useAppContext() {
  return useContext(AppContext);
}
